<template>
    <div>
        <div>
            <van-nav-bar
            title="订单详情"
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
            color="linear-gradient(to right, #ff9900, #ff3333)"
            />
            <van-row class="navBarMsg">
                <van-col span="5" style="text-align:right;margin-left:0.5rem">
                    <img v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 1" src="../assets/imgs/orderStatus/orderinfo_waitforpaying_icon.png" alt="" height="44px">
                    <img v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 2" src="../assets/imgs/orderStatus/orderinfo_waitforfahuo_icon.png" alt="" height="44px">
                    <img v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 3" src="../assets/imgs/orderStatus/orderinfo_express-state_icon.png" alt="" height="44px">
                    <img v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 5" src="../assets/imgs/orderStatus/orderinfo_orderok_icon.png" alt="" height="44px">
                    <img v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 4" src="../assets/imgs/orderStatus/orderinfo_orderok_icon.png" alt="" height="44px">
                    <img v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 0" src="../assets/imgs/orderStatus/orderinfo_ordercancel_icon.png" alt="" height="44px">
                    <img v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 8" src="../assets/imgs/orderStatus/orderinfo_order-refund_icon.png" alt="" height="44px">
                </van-col>
                <van-col span="14" style="color:white;margin-left:1.75rem">
                    <div v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 1" style="font-size:1rem;font-weight:700;margin-bottom:0.4rem">待支付</div>
                    <div v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 2" style="font-size:1rem;font-weight:700;margin-bottom:0.4rem">待发货</div>
                    <div v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 3" style="font-size:1rem;font-weight:700;margin-bottom:0.4rem">待收货</div>
                    <div v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 4" style="font-size:1rem;font-weight:700;margin-bottom:0.4rem">已完成</div>
                    <div v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 5" style="font-size:1rem;font-weight:700;margin-bottom:0.4rem">已完成</div>
                    <div v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 0" style="font-size:1rem;font-weight:700;margin-bottom:0.4rem">已取消</div>
                    <div v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 8" style="font-size:1rem;font-weight:700;margin-bottom:0.4rem">已退款</div>
                    <div v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 1" style="font-size:0.875rem;">订单还未支付</div>
                    <div v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 2" style="font-size:0.875rem;">订单已支付，等待厂家发货中...</div>
                    <div v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 3" style="font-size:0.875rem;" class="overflowEllipsis">订单正在发往{{shoplist.takeOver.shippingAddress}}</div>
                    <div v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 4" style="font-size:0.875rem;">订单已完成，可前往<span>再次购买</span></div>
                    <div v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 5" style="font-size:0.875rem;">订单已完成，可前往<span>再次购买</span></div>
                    <div v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 0" style="font-size:0.875rem;">订单已取消，可前往<span>再次购买</span></div>
                    <div v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 8" style="font-size:0.875rem;">订单已退款，可前往<span>再次购买</span></div>
                </van-col>
                <van-col span="2" style="text-align:center;line-height:44px;" v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 3" @click="goToLogisticsParticulars(shoplist.goods[0].titelOrderId)">
                    <van-icon name="arrow" color="white"/>
                </van-col>
            </van-row>
        </div>
        
        <div style="background:#fafafa;position: relative;">
            <div style="padding:4.5rem 10px 2.7rem;">
                <!-- 收货信息 -->
                <div style="height:4.5rem;background:#fff;position: absolute;top: -1rem;left: 10px;z-index: 1000;width: 95%;border-radius:3px;" class="boxshadow">
                    <van-row>
                        <van-col span="2" style="margin-top:1rem;text-align:right"><van-icon size="1.25rem" color="#FF3333" name="location-o" /></van-col>
                        <van-col span="19" style="font-size:0.875rem;margin-top:1rem;margin-left:10px;">
                            <div style="margin-bottom:0.5rem;font-weight:bold" class="van-ellipsis">{{ shoplist && shoplist.takeOver && shoplist.takeOver.shippingAddress ? shoplist.takeOver.shippingAddress : '' }}</div>
                            <van-row style="font-size:0.75rem;">
                                <van-col span="12" style="text-align:left">{{ shoplist && shoplist.takeOver && shoplist.takeOver.consigneeName ? shoplist.takeOver.consigneeName : ''}}</van-col>
                                <van-col span="12" style="text-align:right">{{ shoplist && shoplist.takeOver && shoplist.takeOver.shippingPhone ? shoplist.takeOver.shippingPhone : ''}}</van-col>
                            </van-row>
                        </van-col>
                    </van-row>
                </div>
                <!-- 订单信息 -->
                <van-panel title="订单信息" style="margin-bottom:1rem;height:8.06rem" class="boxshadow">
                    <div class="orderMsgBox">
                        <van-row  class="colmargin">
                            <van-col span="8">订单编号</van-col>
                            <van-col style="text-align:right" span="16">
                                <span class="copyborder" 
                                v-clipboard:copy="this.$route.query.orderId" 
                                v-clipboard:success="onCopy" 
                                v-clipboard:error="onError">复制</span>
                                {{ this.$route.query.orderId ? this.$route.query.orderId :'' }}</van-col>
                        </van-row>
                        <van-row class="colmargin">
                            <van-col span="12">下单时间</van-col>
                            <van-col span="12" style="text-align:right">{{ shoplist.createTime }}</van-col>
                        </van-row>
                        <van-row class="colmargin">
                            <van-col span="12">订单状态</van-col>
                            <van-col span="12" style="text-align:right">{{ orderState(shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus ? shoplist.goods[0].orderStatus : '') }}</van-col>
                        </van-row>
                    </div>
                </van-panel>
                <!-- 订单明细 -->
                <van-panel title="订单明细" style="margin-bottom:1rem" class="boxshadow">
                    <div class="orderMsgBox">
                        <van-row class="colmargin padding-b-10">
                            <van-col span="12">支付方式</van-col>
                            <van-col span="12" style="text-align:right">微信</van-col>
                        </van-row>
                    </div>
                </van-panel>
                <!-- 商品介绍 -->
                <van-panel class="storeName boxshadow" style="margin-bottom:1rem"  v-for="(item,index) in shoplist.goods" :key="index">
                    <div slot="header">
                        <div style="padding:0 1rem">
                            <div class="van-hairline--bottom"  style="display:flex;align-items: center;padding:0.5rem 0;">
                                <img src="../assets/imgs/shopcart_shopicon_icon@2x.png" width="20px;" height="18px;" alt="" style="margin-right:0.5rem;">
                                <span style="font-size:0.875rem;font-weight:bold">{{ shoplist.factoryName }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="orderMsgBox" style="padding:0">
                        <div class="everyShopList">
                            <div style="background:#fff;padding:5px 10px 0">
                                <div style="padding:5px;">
                                    <van-row style="border:1px solid #FFFFFF;height:6.875rem;display: flex;">
                                        <van-col span="8">
                                            <img style="width:100px" :src="item.goodsUrl" alt="">
                                        </van-col>
                                        <van-col span="15" style="margin-left:0.5rem">
                                            <p style="font-weight: bold;font-size:0.875rem;height:2rem" class="overflowEllipsis">{{ item.goodsName }}</p>
                                            <p style="font-weight: normal;font-size:0.75rem;color:#8c8c8c;margin:0.625rem 0 0.2rem">规格: {{ item.goodsNorms }}</p>
                                            <p>
                                                <span class="fullReduction" v-if="item.fullReductionShow">立减</span>&nbsp;
                                                <span class="fullMail" v-if="item.fullMailShow">包邮</span>&nbsp;
                                                <span class="gifts" v-if="item.giftShow">赠品</span>
                                            </p>
                                            <van-row style="font-weight: bold;font-size:0.875rem;display:flex;align-items: center;">
                                                <van-col span="12">￥{{ item.goodsUnitPrice }}</van-col>
                                                <van-col span="12" style="text-align:right;font-size:0.75rem">数量：{{ item.goodsNum }}</van-col>
                                            </van-row>
                                        </van-col>
                                        <van-col span="1" style="line-height:6.87rem;">
                                            <van-icon name="arrow" />
                                        </van-col>
                                    </van-row>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-panel>
                <!-- 费用信息 -->
                <van-panel title="支付费用" style="margin-bottom:1rem" class="boxshadow">
                     <div class="orderMsgBox">
                        <van-row  class="colmargin">
                            <van-col span="12">商品总额</van-col>
                            <van-col span="12" style="text-align:right">￥{{ shoplist.orderTotalAmount }}</van-col>
                        </van-row>
                        <van-row class="colmargin">
                            <van-col span="12">运费金额</van-col>
                            <van-col span="12" style="text-align:right">￥{{ shoplist.freight }}</van-col>
                        </van-row>
                        <van-row class="colmargin">
                            <van-col span="12">优惠额度</van-col>
                            <van-col span="12" style="text-align:right">-￥{{ shoplist.orderVerticalMoney }}</van-col>
                        </van-row>
                        <van-row style="padding:0.5rem 0;font-size:14px;border-top:1px solid #ebedf0">
                            <van-col span="12">实付金额</van-col>
                            <van-col span="12" style="text-align:right">￥{{ shoplist.orderActualAmount }}</van-col>
                        </van-row>
                    </div>
                </van-panel>
            </div>
        </div>
        <!-- 底部 -->
        <div class="footer">
            <div style="text-align:right;display:flex;justify-content: flex-end" v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 1">
                <div class="operation" @click="cancelOrder">取消订单</div>
                <div class="operation borderfont" @click="payForOrder">前往支付</div>
            </div>
            <div style="text-align:right;display:flex;justify-content: flex-end;" v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 2">
                <div class="operation" @click="reminder(shoplist.goods[0].goodsId)">我要催单</div>
                <div class="operation" @click="refundOrder(shoplist.orderActualAmount)">我要退款</div>
            </div>
            <div style="text-align:right;display:flex;justify-content: flex-end;" v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 3">
                <div class="operation" @click="oneMoreBuy(shoplist)">再次购买</div>
                <div class="operation" @click="lookLogistics(shoplist.goods[0].titelOrderId)">查看物流</div>
                <!-- <div class="operation" @click="reminder(shoplist.goods[0].goodsId)">我要催单</div> -->
                <div class="operation borderfont" @click="trueReceipt">确认收货</div>
            </div>
            <div style="text-align:right;display:flex;justify-content: flex-end;" v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 4">
                <div class="operation" @click="deleteOrder">删除订单</div>
                <div class="operation" @click="goToComment(shoplist.orderId,shoplist.factoryId,shoplist.goods[0].goodsId)">前往评论</div>
                <!-- <div class="operation" @click="refundOrder(shoplist.goods[0].orderPrice)">我要退款</div> -->
                <div class="operation borderfont" @click="oneMoreBuy(shoplist)">再次购买</div>
            </div>
            <div style="text-align:right;display:flex;justify-content: flex-end;" v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 0">
                <div class="operation" @click="deleteOrder">删除订单</div>
                <div class="operation borderfont" @click="oneMoreBuy(shoplist)">再次购买</div>
            </div>
            <div style="text-align:right;display:flex;justify-content: flex-end;" v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 5">
                <div class="operation" @click="deleteOrder">删除订单</div>
                <div class="operation borderfont" @click="oneMoreBuy(shoplist)">再次购买</div>
            </div>
            <div style="text-align:right;display:flex;justify-content: flex-end;" v-if="shoplist && shoplist.goods && shoplist.goods[0] && shoplist.goods[0].orderStatus == 8">
                <div class="operation" @click="deleteOrder">删除订单</div>
                <div class="operation borderfont" @click="oneMoreBuy(shoplist)">再次购买</div>
            </div>
            <!-- <div v-if="shoplist.orderStatus == 0" style="justify-content: flex-end;">
                <van-button  round type="default" size="small" @click="showBuyAgain = true">取消支付</van-button>
                <van-button style="margin-left:1rem" round type="default" size="small" @click="nowPay(shoplist.titelOrderId)">立即支付</van-button>
            </div>
            <div  v-if="shoplist.orderStatus != 0" >
                <van-button  round type="default" size="small" @click="showBuyAgain = true">再次购买</van-button>
                <van-button round type="default" size="small">圆形按钮</van-button>
                <van-button round type="default" size="small">圆形按钮</van-button>
                <van-button round type="default" size="small">圆形按钮</van-button>
            </div> -->

        </div>

        <!-- 再次购买确认 -->
        <van-popup class="buyagain" v-model="showBuyAgain" position="bottom" :style="{ height: '70%' }" round closeable :close-on-click-overlay="false">
            <div class="buyagaintitle">购买确认</div>
            <div class="buyagaincon">
                <div class="buyagaincongoods">
                    <div style="margin-bottom:5rem;border: 1px solid #ccc;" >
                        <div class="orderMsgBox" style="padding:0 0 1rem">
                            <div v-for="(item,index) in shoplist.goods" :key="index" class="everyShopList">
                                <div style="background:#FAFAFA;padding:5px 10px 0">
                                    <div style="padding:5px;">
                                        <van-row style="height:5.5rem;display: flex;">
                                            <van-col span="6">
                                                <img style="width:100%;" :src="item.goodsUrl" alt="">
                                            </van-col>
                                            <van-col span="15" style="margin-left:0.5rem">
                                                <p style="font-weight: bold;font-size:0.875rem;height:2rem" class="overflowEllipsis">{{ item.goodsName }}</p>
                                                <p style="font-weight: normal;font-size:0.75rem;color:#8c8c8c;margin:0.4rem 0 0">规格: {{ item.goodsNorms }}</p>
                                                <van-row style="font-weight: bold;font-size:0.875rem;display:flex;align-items: center;">
                                                    <van-col span="12">￥{{ item.goodsUnitPrice }}</van-col>
                                                    <van-col span="12" style="text-align:right;font-size:0.75rem">
                                                        <van-stepper v-model="item.goodsNum" input-width="40px" button-size="20px" integer max="8"/>
                                                    </van-col>
                                                </van-row>
                                            </van-col>
                                            <van-col span="3" style="font-weight:normal;line-height:5.5rem;text-align:center;color:#666666">
                                                <span style="border-bottom:1px solid #666666;" @click="removegoodsship(index)">移除</span>
                                            </van-col>
                                        </van-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="buybtn" @click="goToBuyAgainshure">
                前往购买
            </div>
        </van-popup>
    </div>
</template>

<script>
import {  NavBar, Row, Col,Icon,Panel,Button ,Popup ,Stepper ,Dialog   } from "vant";
export default {
    components: {
        [NavBar.name]: NavBar,
        [Row.name]: Row,
        [Col.name]: Col,
        [Icon.name]: Icon,
        [Panel.name]: Panel,
        [Button.name]: Button,
        [Popup.name]: Popup,
        [Stepper.name]: Stepper,
        [Dialog.name]: Dialog,
    },
    inject:['reload'],
    data(){
        return{
            shoplist:{},
            value:'',
            showBuyAgain:false,
            orderId:'',
            factoryIdNum:this.local.get('factoryId'),
            paramsgoodsOrder :{
                address:'',
                session:'',
                name:'',
                phone:'',
                giftListShow:'',
                fullReductionListShow:'',
                fullReductionList:'',
                fullMailShow:'',
                goods:[],
                orderAccountMoney:'',
                actualPayment:'',
                freight:'',
            },
        }
    },
    created() {
        console.log('总订单',this.$route.query.totalOrderId)
        console.log('商品订单',this.$route.query.orderId)
        console.log('店铺ID',this.$route.query.factoryId)
        this.getUrlMsg()
        this.getOrderMsg()
    },
    methods:{

        onCopy(e) {
            this.$toast('复制成功');
        },
        onError(e) {
            this.$toast('复制失败');
        },
        //促销，赠品
        getGift(data){
            for(let item of data.goods){
                let params = {
                appid: this.Encryp.appid,
                goodsId:item.goodsId,
                nonce: this.Encryp.nonce,
                timestamp: this.Encryp.timestamp,
                sign:this.$md5(`EZutTZ2alDhXrnstrAappid${this.Encryp.appid}goodsId${item.goodsId}nonce${this.Encryp.nonce}timestamp${this.Encryp.timestamp}EZutTZ2alDhXrnstrA`),
            }
            this.request.get("/v1/goods/gift", params)
                .then(res => {
                    console.log(res.data)
                    if(res.data.giftList && res.data.giftList.length > 0 && res.data.giftList != '' && res.data.giftList != null){
                        item.giftShow = true
                    }
                    if(res.data.fullReductionList && res.data.fullReductionList.length > 0 && res.data.fullReductionList != '' && res.data.fullReductionList != null){
                        item.fullReductionShow = true
                        item.fullReductionList = res.data.fullReductionList
                    }
                    if(res.data.fullMail && res.data.fullMail.length > 0 && res.data.fullMail != '' && res.data.fullMail != null){
                        item.fullMailShow = true
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }
            return data
        },
            
        //订单状态
        orderState(cellValue) {
            if (cellValue == "1") {
                return "待支付";
            } else if (cellValue == "2") {
                return "待发货";
            } else if (cellValue == "3") {
                return "已发货";
            } else if (cellValue == "4") {
                return "已收货";
            } else if (cellValue == "5") {
                return "已完成";
            } else if (cellValue == "6") {
                return "待退款";
            } else if (cellValue == "7") {
                return "待退货";
            } else if (cellValue == "8") {
                return "已退款";
            } else if (cellValue == "0") {
                return "已取消";
            }
        },
        getUrlMsg(){
            var url = window.location.href;
            var querys = url.substring(url.indexOf('?') + 1).split('&');
            var result=[];
            for(var i=0;i<querys.length;i++){
                var temp=querys[i].split('=');
                if(temp.length<2){
                    result[temp[0]]='';
                }else{
                    result[temp[0]]=temp[1];
                }
            }
            this.orderId = result['paysuccessorderId']
            console.log(this.orderId)
        },
        getOrderMsg(){
            let _this = this
            let params = {
            session:this.local.get('session'),
            orderId: this.orderId != '' && this.orderId != null ? this.orderId : this.$route.query.orderId
            }
            // this.request.get("/v1/user/order/get/order",params)
            this.request.get("/v1/user/order/find/factoryOrder",params)
            .then(res => {
                res.data = this.getGift(res.data)
                window.setTimeout(()=>{
                    _this.shoplist = res.data
                },1000)
            })
            .catch(err => {
                console.log(err);
            });
        },
        //   返回
        onClickLeft() {
            this.$router.go(-1);//返回上一层
        },
        /* //立即支付
        nowPay(){
            this.$router.push({path : 'affirmorder' , query:{ orderNum:this.$route.query.totalOrderId,orderId:this.$route.query.orderId }})
        }, */
        goToLogisticsParticulars(data){
            // console.log(data)
            if(this.shoplist.goods[0].orderStatus == 3 ){
                // this.$router.push('orderLogistics')
                // console.log(data)
                this.$router.push({path : 'orderLogistics' , query:{ totalOrderId:data}})
            }else{
                this.$toast('未发货');
            }
        },
        //取消订单
    cancelOrder(){
        Dialog.confirm({
            title: '确认取消该笔订单吗？',
            message: '取消的订单不会删除，可前往取消订单列表中再次购买订单商品'
        }).then(() => {
            let params = {
                session:this.local.get('session'),
                orderId:this.$route.query.orderId,
                titerOrderId:this.$route.query.totalOrderId
            }
            this.request.post("v1/user/order/cancel/order",params)
            .then(res => {
                console.log(res)
                this.getOrderMsg()
                this.reload()
            })
            .catch(err => {
                console.log(err);
            });
        }).catch(() => {
            // on cancel
        });
    },
    //截取ID 
    GetQueryString(name){
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if(r!=null)return  unescape(r[2]); return null;
    },
    //前往支付
    payForOrder(){
        // this.$router.push({path : 'affirmorder' , query:{ orderNum:this.$route.query.totalOrderId,orderId:this.$route.query.orderId }})
        if(this.local.get('openID')){
            this.$router.push({path : 'toorderpay' , query:{ orderNum:totalOrderId,orderId:orderId }})
        }else{
            let localNow = `http://youbesunstore.youbesun.com/#/toorderpay?orderNum=${this.$route.query.totalOrderId}&orderId=${this.$route.query.orderId}`
            var jumpUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?'
            let params = {
                appid: 'wx25eff57029bf3034', // 公众号appid
                // appid: 'wx22ee3b56bd261e8c', // 开放平台appid
                // redirect_uri: encodeURIComponent(window.location.href), //回调地址，域名配置同一地址 定位到目录
                redirect_uri:encodeURIComponent(localNow),
                response_type: 'code',
                scope: 'snsapi_userinfo',// 需要用户确认登录
                // scope: 'snsapi_base',// 需要用户确认登录
                state: ``
            }
            let code = this.GetQueryString("code")
            if(code == '' || code == null){
                jumpUrl += `appid=${params.appid}&redirect_uri=${params.redirect_uri}&response_type=${params.response_type}&scope=${params.scope}&state=${params.state}#wechat_redirect`
                console.log(jumpUrl)
                window.location.href = jumpUrl 
                // this.goToPayOrder()
            }/* else{
                this.saveTheOpenId(code)
            }  */
        }
    },
    // 移除
    removegoodsship(index){
        this.shoplist.goods.splice(index,1);//删除
    },
    //我要退款
    refundOrder(money){
        Dialog.confirm({
            message: '确认对该订单发起退款吗？'
        }).then(() => {
            let params = {
                session:this.local.get('session'),
                orderId:this.$route.query.orderId,
                RefundMoney:money
            }
            console.log(params)
            this.request.post("/v1/user/order/refund",params)
            .then(res => {
                console.log(res)
                // this.reload()
                // this.getOrderMsg()
                this.$router.push('myorderlist')
            })
            .catch(err => {
                console.log(err);
            });
        }).catch(() => {
            // on cancel
        });
    },
    //确认收货
    trueReceipt(){
        Dialog.confirm({
            title: '确认订单商品已到货吗？'
        }).then(() => {
            let params = {
                session:this.local.get('session'),
                orderId:this.$route.query.orderId,
            }
            this.request.post("/v1/user/order/confirm/OrderGoods",params)
            .then(res => {
                console.log(res)
                this.$toast.success(res.message);
                this.getOrderMsg()
                this.reload()
            })
            .catch(err => {
                console.log(err);
            });
        }).catch(() => {
            // on cancel
        });
    },
    //查看物流
    lookLogistics(data){
        this.$router.push({path : 'orderLogistics' , query:{ totalOrderId:data}})
    },
    //我要催单
    reminder(factoryId,goodsId){
        Dialog.confirm({
            title: '确定要申请催单吗？',
            message: '注：催单申请成功后，需12小时后才能再次催单'
        }).then(() => {
            let params = {
                session:this.local.get('session'),
                orderId:this.$route.query.orderId,
                goodsId:goodsId,
                factoryId:this.$route.query.factoryId,
            }
            this.request.get("/v1/user/order/myReminder",params)
            .then(res => {
                console.log(res)
                if(res.message == '1'){
                    this.$toast.success('您的催单申请已发送，请等待厂家处理');
                    this.getOrderMsg()
                    this.reload()
                }else{
                    this.$toast('催单无效，下单24小时后可催单');
                }
            })
            .catch(err => {
                console.log(err);
            });
        }).catch(() => {
            // on cancel
        });
    },
    //再次购买
    oneMoreBuy(data){
        this.showBuyAgain = true
        this.goodsBuyAgainMsg = data
        this.BuyAgaintotalOrderId = data.totalOrderId
        console.log(data)
    },
    //再次购买确认
    goToBuyAgainshure(){
        console.log(this.shoplist)
        let params = {
            session:this.local.get('session'),
            goods:[],
            factoryId:this.goodsBuyAgainMsg.factoryId,
        }
        for(let item of this.goodsBuyAgainMsg.goods){
            params.goods.push({
               skuId:item. skuId,
               goodsId:item.goodsId
            })
        }
        params.goods = JSON.stringify(params.goods)
        console.log(params)
        this.request.post("/v1/user/order/again",params)
        .then(res => {
            console.log(res)
            let paramsa = {
                session:this.local.get('session'),
                orderId:this.BuyAgaintotalOrderId
            }
            this.request.get("/v1/user/order/get/order",paramsa)
            .then(res => {
                console.log(res)
                this.buyAgainAddress = res.data.takeOver
                console.log(this.buyAgainAddress)
                this.paramsgoodsOrder.address = this.buyAgainAddress.shippingAddress,
                this.paramsgoodsOrder.session = this.local.get('session'),
                this.paramsgoodsOrder.name = this.buyAgainAddress.consigneeName,
                this.paramsgoodsOrder.phone = this.buyAgainAddress.shippingPhone
                for(let i=0;i<this.shoplist.goods.length;i++){
                    this.paramsgoodsOrder.goods.push({
                        giftListShow : this.shoplist.goods[i].giftShow ? this.shoplist.goods[i].giftShow : false,
                        fullReductionListShow : this.shoplist.goods[i].fullReductionShow ? this.shoplist.goods[i].fullReductionShow : false,
                        fullMailShow : this.shoplist.goods[i].fullMailShow ? this.shoplist.goods[i].fullMailShow : false,
                        fullReductionList : this.shoplist.goods[i].fullReductionList,
                        goodsUrl : this.shoplist.goods[i].goodsUrl,
                        factoryId : this.shoplist.factoryId,
                        goodsId : this.shoplist.goods[i].goodsId,
                        goods : this.shoplist.goods[i].goodsName,
                        goodsNorms : this.shoplist.goods[i].goodsNorms,
                        userInvitationCode : this.shoplist.goods[i].userInvitationCode,
                        goodsUnitPrice : this.shoplist.goods[i].goodsUnitPrice,
                        goodsPrice : this.shoplist.goods[i].goodsUnitPrice,
                        goodsNum : this.shoplist.goods[i].goodsNum != '' ? this.shoplist.goods[i].goodsNum : 1,
                        skuId : this.shoplist.goods[i].skuId,
                        freight : 20,
                    })
                }
                window.localStorage.removeItem('ship')
                window.localStorage.setItem('ship', JSON.stringify(this.paramsgoodsOrder))
                this.$router.push('affirmorder')
                /* //提交订单
                this.request.post("/v1/user/order/generating",params)
                    .then(res => {
                        console.log(res)
                        if(res.code == 200 && res.message == '操作成功'){
                            this.$router.push({path : 'affirmorder' , query:{ orderNum:res.data,ship:'ship' }})
                        }else if(res.code == 1070){
                            this.$toast('无法购买');
                        }else{
                            this.$toast(res.message);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    }); */
            })
            .catch(err => {
                console.log(err);
            });
        })
        .catch(err => {
            console.log(err);
        });
    },
    //前往评论
    goToComment(orderId,factoryId,goodsId){
        // this.$router.push({path : 'ship' , query:{ comment:'1' }})
        this.$toast('评价功能即将开放，敬请期待');
        /* let params = {
                session:this.local.get('session'),
                orderId:orderId,
                goodsId:goodsId,
                evaluate:'1',
                factoryId:factoryId,
            }
            this.request.post("/v1/user/order/evaluate",params)
            .then(res => {
                console.log(res)
                if(res.code == '200'){
                    // this.getGoodsListApi()
                }
            })
            .catch(err => {
                console.log(err);
            }); */
    },
    //删除订单
    deleteOrder(){
        Dialog.confirm({
            title: '确认删除该订单吗？'
        }).then(() => {
            let params = {
                session:this.local.get('session'),
                orderId:this.$route.query.orderId,
            }
            this.request.delete("/v1/user/order/delete/factoryOrder",params)
            .then(res => {
                console.log(res)
                if(res.message == '删除成功'){
                    this.$router.push('myorderlist')
                    Toast.success('删除成功');
                }

            })
            .catch(err => {
                console.log(err);
            });
        }).catch(() => {
            // on cancel
        });
    },

    },
    
}
</script>

<style lang="less" scoped>
.fullReduction{
    border: 1px solid #FF3333;
    border-radius: 0.75rem;
    display: inline-block;
    width: 2.2rem;
    color: #FF3333;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.65rem;
    text-align: center;
}
.fullMail{
    border: 1px solid #FFCC00;
    border-radius: 0.75rem;
    display: inline-block;
    width: 2.2rem;
    color: #FFCC00;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.65rem;
    text-align: center;
}
.gifts{
    border: 1px solid #0099FF;
    border-radius: 0.75rem;
    display: inline-block;
    width: 2.2rem;
    color: #0099FF;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.65rem;
    text-align: center;
}
.borderfont{
    color: #FF3333;
    border:1px solid #FF3333!important;
}
.van-nav-bar {
    height: 12.75rem;
    background: linear-gradient(to right, #ff9900, #ff3333);
    position: relative;
    .van-icon,
    .van-nav-bar__text,
    .van-nav-bar__title {
      color: #fff;
    }
    .van-nav-bar__left{
        top: 0;
        font-size: 0.875rem;
    }
    .van-nav-bar__title{
        font-weight: bold;
        font-size: 1.25rem;
    }
}
.navBarMsg{
    width: 100%;
    height: 2.75rem;
    position: absolute;
    top: 5.31rem;
    left: 0;
    z-index: 100;
}
.orderMsgBox{
    padding:0 20px;
    font-size: 0.75rem;
    font-weight: 600;
    // background:#FAFAFA;
}
.colmargin{
    margin: 8px 0;
    color: #666;
}
.van-cell__title{
    font-weight: 700;
}
.copyborder{
    display: inline-block;
    border: 1px solid #ccc;
    width: 2.25rem;
    text-align: center;
    font-weight: normal;
    color: #000;
}
.footer{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2.7rem;
    display: flex;
    justify-content: flex-end;
    background: white;
    line-height: 2.7rem;
    align-items: center;
    border-top: 1px solid #E3E3E3;
    .operation{
        margin-left: 15px;
        border: 1px solid rgb(204, 204, 204);
        border-radius: 20px;
        font-size: 13px;
        width: 4.81rem;
        height: 1.5rem;
        text-align: center;
        line-height: 1.5rem;
    }
    div{
        width: 100%;
        padding: 0 0.5rem;
        display: flex;
        justify-content: space-around;
        button{
            width: 5rem;
        }
        .van-button--default {
            border:1px solid #ccc;
        }
        .van-button--small{
            line-height: 1.4rem;
            height: 1.5rem;
        }
    }
}
.van-popup--bottom.van-popup--round{
    border-radius: 5px 5px 0 0;
}
.buyagain{
    .buyagaintitle{
    height: 5.875rem;
    line-height: 5.8rem;
    font-size: 1.375rem;
    text-align: center;
    font-weight: bold;
    }
    .buyagaincon{
        height: 22rem;
        padding: 0 0.5rem;
        .buyagaincongoods{
            background: #FAFAFA;
            height: 100%;
        }
    }
    .buybtn{
        width: 100%;
        height: 3.375rem;
        line-height: 3.3rem;
        text-align: center;
        font-size: 1.1rem;
        background: #FF3333;
        color: white;
        position: fixed;
        bottom: 0;
        left: 0;
    }
}
/deep/ .van-stepper__minus {
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 3px;
}
/deep/ .van-stepper__input{
    background-color: white;
    border: 1px solid #ccc;
    margin: 0 5px;
}
/deep/ .van-stepper__plus{
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 3px;
}
.storeName{
    /deep/ .van-cell{
        padding: 5px 16px;
    }
}
</style>